const MAP = {
  // Loads
  pending: { c: "neutral", l: "PENDING" },
  assigned: { c: "info", l: "ASSIGNED" },
  in_transit: { c: "primary", l: "IN TRANSIT" },
  delivered: { c: "success", l: "DELIVERED" },
  cancelled: { c: "error", l: "CANCELLED" },
  // Drivers
  available: { c: "success", l: "AVAILABLE" },
  on_load: { c: "primary", l: "ON LOAD" },
  off_duty: { c: "neutral", l: "OFF DUTY" },
  // Invoices
  draft: { c: "neutral", l: "DRAFT" },
  sent: { c: "info", l: "SENT" },
  paid: { c: "success", l: "PAID" },
  overdue: { c: "error", l: "OVERDUE" },
  // Maintenance
  scheduled: { c: "info", l: "SCHEDULED" },
  in_progress: { c: "primary", l: "IN PROGRESS" },
  completed: { c: "success", l: "COMPLETED" },
  // Applicants
  new: { c: "info", l: "NEW" },
  screening: { c: "warning", l: "SCREENING" },
  interview: { c: "primary", l: "INTERVIEW" },
  hired: { c: "success", l: "HIRED" },
  rejected: { c: "error", l: "REJECTED" },
  // Leads
  contacted: { c: "warning", l: "CONTACTED" },
  qualified: { c: "primary", l: "QUALIFIED" },
  won: { c: "success", l: "WON" },
  lost: { c: "error", l: "LOST" },
};

export default function StatusPill({ status }) {
  const m = MAP[status] || { c: "neutral", l: (status || "—").toUpperCase() };
  return <span className={`pill pill-${m.c}`} data-testid={`status-${status}`}>{m.l}</span>;
}
